/* eslint-disable no-console */
import {
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { PlatformService } from '../services/platform.service';

let logNumber = 0;

/**
 * http 로그 순서 반환
 */
const getLogNumber = (): string => {
  if (logNumber > 99) {
    logNumber = 0;
  }

  const number = (logNumber < 10 ? '0' : '') + logNumber;
  logNumber += 1;

  return number;
};

/**
 * http 메소드별 로그 색상 문자열 반환
 * @param method http 메소드
 * @returns `console.log` 색상 문자열
 */
const getColor = (method: string): string => {
  switch (method) {
    case 'GET':
      return 'color: #fff; background-color: #2196f3';
    case 'POST':
      return 'color: #fff; background-color: #4caf50';
    case 'PUT':
      return 'color: #fff; background-color: #9c27b0';
    case 'PATCH':
      return 'color: #fff; background-color: #4d2f40';
    case 'DELETE':
      return 'color: #fff; background-color: #f44336';
    default:
      return 'color: #000; background-color: #fff';
  }
};

/**
 * 많이 반복하는 logger 특성상, JSON 객체는 성능 떨어지므로 직접 구현
 */
const deepClone = (o: any): any => {
  if (o === null || typeof o !== 'object') {
    return o;
  }

  const result: any = Array.isArray(o) ? [] : {};

  Object.keys(o).forEach((key) => {
    result[key] = deepClone(o[key]);
  });

  return result;
};

/**
 * http 로깅 인터셉터 Fn
 */
export const loggingInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  if (environment.production) {
    return next(req);
  }

  const platformService = inject(PlatformService);

  const number = platformService.isPlatformServer ? 0 : getLogNumber();
  const startTime = Date.now();
  const limit = 1000;
  let status = '실패';
  let res: any = null;

  return next(req).pipe(
    tap((event) => {
      if (event instanceof HttpResponse) {
        status = '성공';
        res = event.body;
      }
    }),
    finalize(() => {
      const elapsedTime = Date.now() - startTime;
      const message = `${status}, ${new Date().toLocaleTimeString()}, ${elapsedTime} ms`;

      if (platformService.isPlatformServer) {
        // console.group(`%c ${req.method}`, getColor(req.method));
        return;
      } else {
        console.group(`%c ${req.method} ${number}`, getColor(req.method));
      }
      console.log('URL', req.urlWithParams);
      if (elapsedTime > limit) {
        console.debug('MSG', message, `(${limit}ms 초과)`);
      } else {
        console.log('MSG', message);
      }
      console.log('REQ', deepClone(req));
      console.log('RES', deepClone(res));
      console.groupEnd();
    }),
  );
};
